var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { HIGHEST_PREMIUM_DISCOUNT, HIGHEST_PREMIUM_DISCOUNT_STREAM, PREMIUM_DISCOUNT_LAST_UPDATED_TIME, } from "../../../interface/DrivingMarket/iHighestPremiumDiscount";
import { drivingMarketStream } from "@domains/features/Markets/Futures/utils/streamingUpdate";
var initState = {
    highestPremiumDiscountData: [],
    latestUpdatedTime: "",
};
var highestPremiumDiscountReducer = function (state, action) {
    var _a;
    if (state === void 0) { state = initState; }
    switch (action.type) {
        case HIGHEST_PREMIUM_DISCOUNT:
            return __assign(__assign({}, state), { highestPremiumDiscountData: action.payload.highestPremiumDiscountData });
        case HIGHEST_PREMIUM_DISCOUNT_STREAM:
            return __assign(__assign({}, state), { highestPremiumDiscountData: drivingMarketStream(state.highestPremiumDiscountData, action.payload.qouteStream), latestUpdatedTime: (_a = action.payload.qouteStream) === null || _a === void 0 ? void 0 : _a.updatedTime });
        case PREMIUM_DISCOUNT_LAST_UPDATED_TIME:
            return __assign(__assign({}, state), { latestUpdatedTime: action.payload.latestUpdatedTime });
        default:
            return state;
    }
};
export default highestPremiumDiscountReducer;
